'use client';

import * as React from 'react';
import {
  useFormContext,
  Controller,
  FieldPath,
  FieldValues,
  FormProvider,
} from 'react-hook-form';
import { FormField as BaseFormField } from './form-field';

export function Form<T extends FieldValues>({
  children,
  ...props
}: React.ComponentProps<typeof FormProvider> & { children: React.ReactNode }) {
  return <FormProvider {...props}>{children}</FormProvider>;
}

export function FormItem<T extends FieldValues, P extends FieldPath<T>>({
  name,
  label,
  required,
  hint,
  children,
}: {
  name: P;
  label: string;
  required?: boolean;
  hint?: string;
  children: React.ReactNode;
}) {
  const { control, formState: { errors } } = useFormContext<T>();
  const errorMessage = errors[name]?.message as string | undefined;

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <BaseFormField 
          label={label} 
          htmlFor={name} 
          required={required} 
          error={errorMessage} 
          hint={hint}
        >
          {/* Safely clone props only if it's a single valid React element */}
          {React.isValidElement(children) 
            ? React.cloneElement(children, { ...field, id: name } as any)
            : children}
        </BaseFormField>
      )}
    />
  );
}
